"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _StreamingCardComponent = _interopRequireDefault(require("./StreamingCardComponent"));
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _buySellSelectors = require("../../redux/selectors/buySellSelectors");
require("./StreamingCardGrid.css");
var _reactRedux = require("react-redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var streamingCardGridClasses = (0, _cssClassesHelper.getBEMClasses)('streaming-card-grid');
var TIF_GTC = 'TIF: GTC';
var TIF_FOK = 'TIF: FOK';
var TIF_IOC = 'TIF: IOC';
var StreamingCardGrid = /*#__PURE__*/(0, _react.memo)(function (props) {
  var store = (0, _reactRedux.useStore)();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentPos = _useState2[0],
    setCurrentPos = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentVal = _useState4[0],
    setCurrentVal = _useState4[1];
  var _useState5 = (0, _react.useState)(function () {
      return props.instruments.map(function () {
        return {
          qty: 0,
          orderTypeValue: TIF_GTC,
          slipage: 10,
          min: 0,
          max: 0,
          newBuyPrice: '',
          newSellPrice: '',
          limitBuyPrice: '',
          limitSellPrice: ''
        };
      });
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    defaultSelection = _useState6[0],
    setDefaultSelection = _useState6[1];
  var _useState7 = (0, _react.useState)(TIF_GTC),
    _useState8 = _slicedToArray(_useState7, 2),
    setOrderTypeCounter = _useState8[1];
  var _useState9 = (0, _react.useState)([{
      value: TIF_GTC,
      label: TIF_GTC
    }, {
      value: TIF_FOK,
      label: TIF_FOK
    }, {
      value: TIF_IOC,
      label: TIF_IOC
    }]),
    _useState10 = _slicedToArray(_useState9, 1),
    orderType = _useState10[0];
  var selectOrderType = function selectOrderType(position, e) {
    var newSelection = _objectSpread({}, defaultSelection);
    newSelection[position].orderTypeValue = e.target.value;
    newSelection[position].slipage = 10;
    setDefaultSelection(newSelection);
    setOrderTypeCounter(e.target.value);
    if (e.target.value == TIF_GTC) {
      setTimeout(function () {
        setDefaultSlippage(0);
      }, 100);
    } else {
      setTimeout(function () {
        setDefaultSlippage(10);
      }, 100);
    }
  };
  var clearForm = function clearForm() {
    var result = Object.assign({}, defaultSelection);
    for (var _i = 0, _Object$entries = Object.entries(result); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
        key = _Object$entries$_i[0];
      result[key].qty = 0;
    }
    setCurrentPos(-1);
    setCurrentVal(-1);
    setDefaultSelection(result);
    props.reset();
  };
  var setQuantityDataForSelection = (0, _react.useCallback)(function (selectedPosition, selectedValue) {
    if (currentPos != -1) {
      setDefaultSelection(function (defaultSelection) {
        var _props$instruments$se;
        var instrumentId = (_props$instruments$se = props.instruments[selectedPosition]) === null || _props$instruments$se === void 0 ? void 0 : _props$instruments$se.InstrumentId;
        var newSelection = _objectSpread({}, defaultSelection);
        if (selectedPosition != currentPos && newSelection[currentPos]) {
          props.changeReduxForm({
            field: 'quantity-' + currentPos,
            value: 0
          });
          newSelection[currentPos].qty = 0;
          newSelection[currentPos].newBuyPrice = '';
          newSelection[currentPos].newSellPrice = '';
          newSelection[currentPos].limitBuyPrice = '';
          newSelection[currentPos].limitSellPrice = '';
        }
        if (instrumentId != props.selectedInstrumentId) {
          props.setInstrument({
            selectedInstrumentId: props.selectedInstrumentId,
            instrumentId: instrumentId
          });
        }
        var state = store.getState();
        var newBuyPrice = (0, _buySellSelectors.getPriceDataForQuantitiesSelector)(state, '0', [parseFloat(selectedValue)]);
        var newSellPrice = (0, _buySellSelectors.getPriceDataForQuantitiesSelector)(state, '1', [parseFloat(selectedValue)]);
        if (newSelection[selectedPosition]) {
          newSelection[selectedPosition].qty = parseFloat(selectedValue);
          newSelection[selectedPosition].newBuyPrice = newBuyPrice[0].pricePerUnit != null ? newBuyPrice[0].pricePerUnit : '';
          newSelection[selectedPosition].newSellPrice = newSellPrice[0].pricePerUnit != null ? newSellPrice[0].pricePerUnit : '';
          newSelection[selectedPosition].limitBuyPrice = newBuyPrice[0].limitPrice != null ? newBuyPrice[0].limitPrice : '';
          newSelection[selectedPosition].limitSellPrice = newSellPrice[0].limitPrice != null ? newSellPrice[0].limitPrice : '';
        }
        return newSelection;
      });
    }
  }, [currentPos, props.instruments, props.selectedInstrumentId]);
  (0, _react.useEffect)(function () {
    if (props.formData && props.formData.active && props.formData.active.includes('slipage')) {
      var selectedPosition = props.formData.active.split('-')[1];
      var selectedValue = props.formData.values ? props.formData.values[props.formData.active] : 0;
      if (selectedValue > 0) {
        setDefaultSelection(function (defaultSelection) {
          var newSelection = _objectSpread({}, defaultSelection);
          newSelection[selectedPosition].slipage = parseFloat(selectedValue);
          return newSelection;
        });
      }
    } else if (props.formData && props.formData.active && props.formData.active.includes('quantity')) {
      var _selectedPosition = props.formData.active.split('-')[1];
      var _selectedValue = props.formData.values ? props.formData.values[props.formData.active] : 0;
      setCurrentPos(_selectedPosition);
      setCurrentVal(_selectedValue);
      setQuantityDataForSelection(_selectedPosition, _selectedValue);
    }
  }, [props.formData, setQuantityDataForSelection]);
  (0, _react.useEffect)(function () {
    setQuantityDataForSelection(currentPos, currentVal);
  }, [props.level1, currentPos, currentVal, setQuantityDataForSelection]);
  (0, _react.useEffect)(function () {
    props.instruments.forEach(function (inst) {
      props.getLevel1Data(inst.InstrumentId);
    });
    return function () {
      props.instruments.filter(function (i) {
        return i.InstrumentId !== props.selectedInstrumentId;
      }).forEach(function (inst) {
        props.unsubscribeLevel1(inst.InstrumentId);
      });
    };
  }, [props.instruments]);
  var setDefaultSlippage = function setDefaultSlippage(value) {
    props.instruments.map(function (item, position) {
      props.changeReduxForm({
        field: "slipage-".concat(position),
        value: value
      });
    });
  };
  var items = props.instruments.map(function (item, position) {
    return /*#__PURE__*/_react["default"].createElement(_StreamingCardComponent["default"], {
      key: position,
      defaultSelection: defaultSelection,
      position: position,
      instrument: item,
      formData: props.formData,
      products: props.products,
      level1: props.level1,
      productManifest: props.productManifest,
      orderType: orderType,
      selectOrderType: selectOrderType,
      AccountId: props.AccountId,
      showNotification: props.showNotification,
      clearForm: clearForm,
      selectedInstrumentId: props.selectedInstrumentId,
      additionalSlipage: props.additionalSlipage
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.fetching || !!items.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardGridClasses()
  }, props.fetching ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null) : items) : '');
});
StreamingCardGrid.displayName = 'StreamingCardGrid';
var _default = exports["default"] = StreamingCardGrid;